import React, { useState, useEffect, useRef } from "react";
import { API_Link, validateHeader } from "../commons/Constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import gif from "./../assets/img/spin.gif";
import { useSnackbar } from "notistack";
import { Modal, Button, ProgressBar, Form } from "react-bootstrap";
import { saveAs } from "file-saver";
import { FiFilter } from "react-icons/fi";
import { BsSortAlphaDown } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import { BiErrorCircle } from "react-icons/bi";
import { FaExclamationTriangle } from "react-icons/fa";
import Select from "react-select";
import parse from "html-react-parser";

const SearchAbstractsComponent = () => {
  const navigate = useNavigate();
  const MD5hash = validateHeader();
  const { enqueueSnackbar } = useSnackbar();
  const [searchResults, setSearchResults] = useState([]);
  const [isActive, setIsActive] = useState(null);
  const [studyId, setStudyId] = useState("");
  const [selectedArticles, setSelectedArticles] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;
  const [isDeleting, setIsDeleting] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [totalarticles, setTotalarticles] = useState();
  const [normalizedValues, setNormalizedValues] = useState([]); // State for normalized values
  const [isFilterAppliedButton, setIsFilterAppliedButton] = useState(false);
  const [isFetchingArticlesAPICalled, setIsFetchingArticlesAPICalled] =
    useState(false);
  const [showError, setShowError] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const filtered = searchResults.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
  }, [searchResults]);
  const toggleFilterModal = () => {
    const filtered = searchResults?.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
    setShowFilterModal(!showFilterModal);
    setIsFilterAppliedButton(true);
  };
  const OpenFilterModal = () => {
    setShowFilterModal(!showFilterModal);
  };
  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const selectOptions = currentOptions?.map((option) => {
    let labelPrefix = "";
    switch (filterType) {
      case "year":
        labelPrefix = "year";
        break;
      case "author":
        labelPrefix = "authors";
        break;
      case "journal":
        labelPrefix = "journal";
        break;
      default:
        break;
    }

    // Return the option with prefixed label
    return {
      value: option,
      label: option,
      labelPrefix: labelPrefix,
    };
  });
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  const handleExport = () => {
    const risData = searchResults
      ?.map((item, index) => {
        const authors = item.authors
          ?.split(",")
          ?.map((author) => author.trim())
          .join("\nA1  - ");
        return (
          `TY  - JOUR\n` +
          `ID  - ${item.id}\n` +
          `T1  - ${item.title}\n` +
          `A1  - ${authors}\n` +
          `CA  - ${item.created_at}\n` +
          `AB  - ${item.abstract}\n` + // N2 is the RIS tag for abstract
          `CS  - ${item.current_stage}\n` + // Custom tag for stage
          `DO  - ${item.doi}\n` + // DOI if available
          `J1  - ${item.journal}\n` + // Journal name
          `S1  - ${item.source}\n` + // Publisher/source
          `PI  - ${item.pico_search_id}\n` + // Custom tag for search ID
          `PD  - ${item.pub_date}\n` + // Custom tag for publication date
          `FP  - ${item.file_path}\n` + // Custom tag for file path
          `RI  - ${item.review_id}\n`
        ); // Custom tag for review ID
      })
      .join("\n");

    const blob = new Blob([risData], {
      type: "application/x-research-info-systems",
    });

    saveAs(blob, "data.ris");
  };

  function shouldBeUppercase(word, index, length) {
    if (index === 0 || index === length - 1) return true;
    return !smallWords.test(word.toLowerCase());
  }
  const toggleCloseModal = () => {
    setSelectedOptions([]);
    setCurrentOptions([]);
    setNormalizedValues([]);
    setFilterType("");
    setFilteredArticles(searchResults);
    setIsFilterAppliedButton(false);
  };
  const toggleHideModal = () => {
    setShowFilterModal(!showFilterModal);
  };
  function convertFirstLetterToUpperCase(str) {
    if (!str) {
      return "";
    }
    const words = str.split(" ");
    return words
      ?.map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.toLowerCase()
      )
      .join(" ");
  }
  const formatOvidTags = (text) => {
    if (!text) return "";

    const formattedText = text
      .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<br><b>$1</b>")
      .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
      .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
      .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
      .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
      .replace(/<ovid:br\/>/g, "<br>")
      .replace(
        /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
        "<a href='$1'>$2</a>"
      )
      .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
      .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
      .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>");
    return formattedText.replace(
      /^(<.*?>)*(\w)/,
      (match, tags, firstLetter) => `${tags || ""}${firstLetter.toUpperCase()}`
    );
  };
  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }

    return str
      .split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }
  useEffect(() => {
    const getPermissionCall = () => {
      var config = {
        method: "get",
        url: `${API_Link}getAllowedStages?review_id=${localStorage.getItem(
          "studyId"
        )}`,
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      };
      axios(config)
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    };

    const fetchSearchResults = async () => {
      let page = 1;
      let totalPages = 1;
      const perPage = 100;

      try {
        const studyId = localStorage.getItem("studyId");
        let allResults = []; // Initialize results array
        setIsLoading(true);
        do {
          const config = {
            method: "get",
            url: `${API_Link}getReviewArticles`,
            params: {
              review_id: studyId,
              page: page,
              per_page: perPage,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "misr-auth": MD5hash,
            },
          };

          const response = await axios(config);
          const resData = response?.data?.articles;
          setTotalarticles(resData?.total);

          allResults = [...allResults, ...resData?.data];

          setSearchResults((prevResults) => [...prevResults, ...resData?.data]);

          totalPages = resData?.last_page; // Update totalPages
          page++;
          const progressPercent = Math.min((page / totalPages) * 100, 100);
          setProgress(progressPercent);
        } while (page <= totalPages);
      } catch (error) {
        console.log(error);
        setShowError(true);
        setIsLoading(false);
        setIsFetchingArticlesAPICalled(true);
      } finally {
        setIsLoading(false);
        // setShowError(false);
        setIsFetchingArticlesAPICalled(true);
      }
    };

    getPermissionCall();
    setStudyId(localStorage.getItem("studyId"));
    fetchSearchResults();

    localStorage.setItem("pageId", "1101");
    localStorage.setItem("subPageId", "1114");
  }, [token]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedArticles(filteredArticles?.map((article) => article.id));
      enqueueSnackbar("All artices selected to be delted", {
        variant: "success",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } else {
      setSelectedArticles([]);
    }
  };

  const handleSelectArticle = (articleId) => {
    setSelectedArticles((prevSelectedArticles) => {
      const isChecked = !prevSelectedArticles.includes(articleId);
      const updatedArticles = isChecked
        ? [...prevSelectedArticles, articleId]
        : prevSelectedArticles.filter((id) => id !== articleId);

      return updatedArticles;
    });
  };

  const handleClick = (index) => {
    setIsActive(isActive === index ? null : index);
  };

  const findDuplicate = () => {
    localStorage.setItem("pageId", 1201);
    navigate("/screeningduplicate");
  };

  const handleDeleteArticles = () => {
    setShowRemove(true);
  };

  const deleteSelectedArticles = async () => {
    setIsDeleting(true);
    try {
      const config = {
        method: "delete",
        url: API_Link + "deleteReviewArticles",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        params: {
          ids: selectedArticles,
        },
      };

      let response = await axios(config);
      if (response.data.status === 1) {
        setSearchResults((prevResults) =>
          prevResults.filter(
            (article) => !selectedArticles.includes(article.id)
          )
        );
        setSelectedArticles([]);
        enqueueSnackbar("Selected articles deleted successfully", {
          variant: "success",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
      toggleCloseModal();
    } catch (error) {
      console.error("Error deleting articles:", error);
      enqueueSnackbar("Failed to delete selected articles", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } finally {
      setIsDeleting(false);
      setShowRemove(false);
      toggleCloseModal();
    }
  };
  const year = [...new Set(searchResults?.map((article) => article?.year))];
  const authors = [
    ...new Set(
      searchResults?.map((article) => article?.authors?.split(",")[0]?.trim())
    ),
  ];
  const journals = [
    ...new Set(searchResults?.map((article) => article?.journal)),
  ];

  const hideRemoveModal = () => {
    setShowRemove(false);
  };

  // Sort articles based on selected field
  const sortArticles = (field) => {
    const sorted = [...filteredArticles].sort((a, b) => {
      const valueA = a[field] ? a[field].toString().toLowerCase() : "";
      const valueB = b[field] ? b[field].toString().toLowerCase() : "";
      if (field === "year") {
        return parseInt(valueB) - parseInt(valueA);
      }
      return valueA.localeCompare(valueB);
    });
    setFilteredArticles(sorted);
    setShowDropdown(false);
  };
  const handleFilterChange = (type) => {
    setFilterType(type);

    const normalizedValues = selectedOptions.reduce(
      (acc, option) => {
        if (!acc[option.labelPrefix]) acc[option.labelPrefix] = [];
        acc[option.labelPrefix].push(option.value.toString().toLowerCase());
        return acc;
      },
      { authors: [], journal: [], year: [] }
    );

    const { authors, journal, year } = normalizedValues;

    switch (type) {
      case "year":
        const filteredYears =
          authors.length === 0 && journal.length === 0
            ? [...new Set(searchResults?.map((article) => article.year))]
            : searchResults
                .filter(
                  (article) =>
                    (authors.length === 0 ||
                      authors.some((author) =>
                        article.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                ?.map((article) => article.year)
                .filter((year, index, self) => self.indexOf(year) === index);

        setCurrentOptions(filteredYears.sort((a, b) => b - a));
        break;

      case "author":
        const filteredAuthors =
          year.length === 0 && journal.length === 0
            ? [
                ...new Set(
                  searchResults.flatMap((article) =>
                    article.authors
                      .split(",")
                      ?.map((a) => a.trim().toLowerCase())
                  )
                ),
              ]
            : searchResults
                .filter(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (journal.length === 0 ||
                      journal.includes(article.journal.toLowerCase()))
                )
                .flatMap((article) =>
                  article.authors.split(",")?.map((a) => a.trim().toLowerCase())
                )
                .filter(
                  (author, index, self) => self.indexOf(author) === index
                ); // Remove duplicates

        // Capitalize the first letter of each word in the filtered authors
        const capitalizedAuthors = filteredAuthors?.map(capitalizeWords);
        setCurrentOptions(capitalizedAuthors);
        break;

      case "journal":
        const filteredJournals =
          year.length === 0 && authors.length === 0
            ? journals
            : journals.filter((journal) =>
                searchResults.some(
                  (article) =>
                    (year.length === 0 ||
                      year.includes(article.year.toString().toLowerCase())) &&
                    (authors.length === 0 ||
                      authors.some((author) =>
                        article.authors
                          .split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(author)
                      )) &&
                    article.journal.toLowerCase() === journal.toLowerCase()
                )
              );

        setCurrentOptions(filteredJournals?.map(capitalizeWords));
        break;

      default:
        setCurrentOptions([]);
        break;
    }
  };

  const handleSelectChange = (options) => {
    setSelectedOptions(options || []);
  };
  const filterArticles = (selectedValues) => (article) => {
    if (!selectedValues.length) {
      setNormalizedValues([]);
      return true;
    }

    const years = selectedValues
      .filter((option) => option.labelPrefix === "year")
      .map((option) => String(option.value).toLowerCase().trim());

    const authors = selectedValues
      .filter((option) => option.labelPrefix === "authors")
      ?.map((option) => option.value.toLowerCase().trim());

    const journals = selectedValues
      .filter((option) => option.labelPrefix === "journal")
      ?.map((option) => option.value.toLowerCase().trim());

    // Normalize and store selected values
    setNormalizedValues([...years, ...authors, ...journals]);

    const yearMatch =
      !years.length || years.includes(String(article.year).toLowerCase());

    const articleAuthors = article?.authors
      ? article.authors
          .split(",") // Split the authors by commas
          ?.map((author) => author.trim().toLowerCase()) // Trim and normalize
      : [];

    const authorMatch =
      !authors.length ||
      authors.some((author) =>
        articleAuthors.some((articleAuthor) => articleAuthor.includes(author))
      );

    const journalMatch =
      !journals.length ||
      journals.some((journal) =>
        (article?.journal || "").toLowerCase().includes(journal)
      );

    return yearMatch && authorMatch && journalMatch;
  };

  const highlightText = (text) => {
    if (!normalizedValues) return text;

    // Convert text to a string if it's not already a string
    const textString = typeof text === "string" ? text : String(text);

    const highlighted = normalizedValues?.find((value) =>
      textString.toLowerCase().includes(value)
    );

    if (!highlighted) return textString;

    const parts = textString.split(new RegExp(`(${highlighted})`, "gi"));
    return parts?.map((part, index) =>
      part?.toLowerCase() === highlighted ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // click outside to remove drop down
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  return (
    <div className="page--content " onClick={handleClickOutside}>
      <div className="position-sticky position-sticky-top">
        <div className="page--section">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="page--heading">Total Results</h1>
            </div>
            <div className="col-lg-6 text-end">
              <button
                className={
                  searchResults?.length === 0 || isLoading
                    ? "btn btn-warning me-2 cursor-not-allowed"
                    : "btn btn-warning me-2 "
                }
                ssss
                onClick={findDuplicate}
                disabled={searchResults?.length === 0 || isLoading}
              >
                Find Duplicates
              </button>

              <button
                className={
                  searchResults?.length === 0 || isLoading
                    ? "btn btn-primary cursor-not-allowed"
                    : "btn btn-primary "
                }
                onClick={handleExport}
                disabled={searchResults?.length === 0 || isLoading}
              >
                Export RIS
              </button>

              <button
                className="btn btn-danger"
                onClick={handleDeleteArticles}
                disabled={
                  selectedArticles.length === 0 ||
                  searchResults?.length === 0 ||
                  isLoading
                }
              >
                Delete
              </button>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col select-all-delet form-check d-flex content-align-center  ">
              <>
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={
                    selectedArticles?.length === filteredArticles?.length
                  }
                  onChange={handleSelectAll}
                />
                <label className="form-check-label">Select All (Delete)</label>
              </>
              <>
                <div
                  style={{
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                >
                  <button
                    onClick={toggleDropdown}
                    className={
                      filteredArticles?.length === 0 || isLoading
                        ? "d-flex content-align-center align-items-center sort-filter-btn cursor-not-allowed opacity-50"
                        : "d-flex content-align-center align-items-center sort-filter-btn"
                    }
                    disabled={filteredArticles?.length === 0 || isLoading}
                  >
                    <BsSortAlphaDown size={18} /> Sort
                  </button>
                  {showDropdown && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "30px",
                        left: 0,
                        backgroundColor: "#ffff",
                        boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                        zIndex: 1,
                        padding: "8px",
                      }}
                    >
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("title")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Title
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("journal")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Journal
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("authors")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Authors
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("year")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Year
                      </div>
                    </div>
                  )}

                  {isFilterAppliedButton ? (
                    <div className="applied-filter-btn">
                      <div
                        className="d-flex content-align-center align-items-center applied-filter-svg"
                        onClick={OpenFilterModal}
                      >
                        <FiFilter size={18} /> Applied
                      </div>
                      <div
                        onClick={() => {
                          toggleCloseModal();
                        }}
                        className="ms-2 d-flex content-align-center align-items-center applied-cross-btn  fw-bold"
                      >
                        <MdCancel size={18} />
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={OpenFilterModal}
                      className={
                        filteredArticles?.length === 0 || isLoading
                          ? "sort-filter-btn d-flex content-align-center align-items-center cursor-not-allowed opacity-50"
                          : "sort-filter-btn d-flex content-align-center align-items-center"
                      }
                      disabled={filteredArticles?.length === 0 || isLoading}
                    >
                      <FiFilter size={18} /> Filter
                    </button>
                  )}
                </div>
                <Modal
                  show={showFilterModal}
                  onHide={toggleHideModal}
                  className="overflow-hidden"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Filter Options</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Form className="d-flex justify-content-around mb-2">
                        <Form.Check
                          type="radio"
                          label="Year"
                          name="filterType"
                          value="title"
                          checked={filterType === "year"}
                          onChange={() => handleFilterChange("year")}
                        />
                        <Form.Check
                          type="radio"
                          label="Author"
                          name="filterType"
                          value="author"
                          checked={filterType === "author"}
                          onChange={() => handleFilterChange("author")}
                        />
                        <Form.Check
                          type="radio"
                          label="Journal"
                          name="filterType"
                          value="journal"
                          checked={filterType === "journal"}
                          onChange={() => handleFilterChange("journal")}
                        />
                      </Form>
                      <Select
                        options={selectOptions}
                        isMulti
                        value={selectedOptions}
                        onChange={handleSelectChange}
                        closeMenuOnSelect={false}
                        placeholder="Select filter options..."
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={toggleCloseModal}>
                      Reset
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        toggleFilterModal();
                      }}
                    >
                      Apply Filter
                    </Button>
                  </Modal.Footer>
                </Modal>
              </>
            </div>
            <div className="col text-end me-3 count-colour">
              <label>
                {isFilterAppliedButton ? (
                  <span className="me-3 text-dark">
                    <strong>Filtered Article(s) </strong>
                    {filteredArticles.length} out of {searchResults?.length}
                  </span>
                ) : (
                  <span className="me-3 text-dark">
                    Total Articles: <strong>{searchResults?.length}</strong>
                  </span>
                )}
              </label>
              <label className="ms-3">
                Selected (Delete): <strong>{selectedArticles?.length}</strong>
              </label>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="progressBarData">
            <ProgressBar now={progress} />
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-lg-12">
          {filteredArticles.length > 0 &&
            filteredArticles?.map(
              ({ id, title, authors, abstract, journal, doi, year }, index) => (
                <div className="form-check col-lg-12" key={id}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedArticles.includes(id)}
                    onChange={() => handleSelectArticle(id)}
                  />
                  <div className="inner--box--row">
                    <span className="index--numbering fw-bold">
                      {index + 1})
                    </span>
                    <div className="width-100">
                      <h1 className="heading3">
                        {title &&
                          parse(
                            formatOvidTags(convertFirstLetterToUpperCase(title))
                          )}
                      </h1>
                      <div className="d-flex ">
                        <p className="small text-muted authors-font ms-1">
                          <span className="authors-font fw-bold">
                            Author(s):
                          </span>{" "}
                          {authors &&
                            highlightText(
                              capitalizeWords(authors.replace(/,/g, ", ")) +
                                ".",
                              normalizedValues
                            )}
                        </p>
                      </div>
                      {journal ? (
                        <label
                          className="small text-muted journal-font"
                          htmlFor="flexCheckDefault2"
                        >
                          <span className="fw-bold">Journal:</span>{" "}
                          {highlightText(
                            capitalizeWords(journal) + ".",
                            normalizedValues
                          )}
                        </label>
                      ) : (
                        ""
                      )}
                      <div>
                        {doi ? (
                          <label
                            className="small text-muted"
                            htmlFor="flexCheckDefault2"
                          >
                            <span className="fw-bold">doi:</span>{" "}
                            {doi?.split("https://dx.doi.org/")[1]}
                          </label>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* <p
                        className="small text-muted"
                        htmlFor="flexCheckDefault2"
                      >
                        PMID: {id}
                      </p> */}
                      <div>
                        {year ? (
                          <label className="small text-muted journal-font">
                            <span className="fw-bold">Year:</span>{" "}
                            {highlightText(year, normalizedValues)}
                          </label>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* <p
                        className={
                          isActive === index
                            ? "Increase-height--of--paragraph"
                            : "Reduce-height--of--paragraph"
                        }
                        onClick={() => handleClick(index)}
                      >
                        {abstract && parse(formatOvidTags(abstract))}
                      </p> */}
                      {/*  */}
                      <p
                        className={
                          isActive === index
                            ? "Increase-height--of--paragraph "
                            : "Increase-height--of--paragraph underline-showAbstarct"
                        }
                        onClick={() => handleClick(index)}
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {isActive === index
                          ? (abstract && parse(formatOvidTags(abstract))) ||
                            "No Abstract Available"
                          : "Show Abstract"}
                      </p>
                    </div>
                  </div>
                </div>
              )
            )}

          {isLoading && (
            <div
              className={
                searchResults?.length >= 100 ? "loading-second-time" : "preload"
              }
            >
              <img src={gif} alt="Loading..." />
            </div>
          )}
          {isFetchingArticlesAPICalled &&
            searchResults?.length === 0 &&
            !isLoading &&
            !showError && (
              <div className="no-data-found-main">
                <h5 className="no-data-found text-muted m-auto opacity-50">
                  <FaExclamationTriangle size={50} color="orange" />
                  <span className="ms-3">No Search and Imported Abstracts</span>
                </h5>
              </div>
            )}
          {isFetchingArticlesAPICalled && showError && (
            <div className="no-data-found-main">
              <h5 className="no-data-found text-muted m-auto opacity-50">
                <BiErrorCircle size={50} color="orange" />
                <span className="ms-3">Some thing went wrong</span>
              </h5>
            </div>
          )}
        </div>
      </div>

      <Modal
        className="modal-dialog-centered "
        show={showRemove}
        onHide={hideRemoveModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Articles!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please confirm do you want to delete {selectedArticles.length}{" "}
          Articles ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={hideRemoveModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={deleteSelectedArticles}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting" : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SearchAbstractsComponent;
